import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useLocation, useHistory } from 'react-router-dom';
import { getProductForm, getRelatedTransactions } from "../../redux/actions/productFrom.action"
import { getAllItem, getOneItem, deleteItem } from "../../redux/actions/item.action"
import { getCombination } from '../../redux/actions/generateCombination.action';
import { updateItem } from '../../redux/actions/item.action';
import { getRights } from "../../redux/actions/userRights.action";
import { getLog } from "../../redux/actions/log.action"
import PageHeader from "../../components/PageHeader/PageHeader";
import CrudButtons from "./CrudButtons";
import SubTitle from "../../components/SubTitle/SubTitle";
import Tables from '../../components/Table/Tables';
import notification from "../../utils/notification"
import { logColumns } from "../../utils/cols"
import { ReadCookie } from "../../utils/readCookie"
import Loader from "react-loader-spinner";
import ProductPrimaryFormForUpdate from '../../components/Form/ProductPrimaryFormForUpdate';
import { Button, Tabs, Modal, Input, Form, Row, Col, Popconfirm, Tooltip } from 'antd';
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"
import "../Style/style.css";
import "./updateproduct.css";
import { getProductType } from '../../redux/actions/productType.action';
import { TabTitle } from '../../utils/GeneralFunction';
import { getSeasonYear } from '../../redux/actions/seasonYear.action';

const { TabPane } = Tabs;

export default function UpdateProductInfo({ token }) {
    TabTitle("Product-Information")
    const history = useHistory();
    const menuId = ReadCookie('menuId');
    const dCompanyId = ReadCookie('defaultCompany')
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { productForm, item, log, userRights, styleCombination, seasonYear } = useSelector(state => state);
    const [companyId, setCompanyId] = useState(ReadCookie('defaultCompany'));
    const queryParams = new URLSearchParams(window.location.search);

    const [minimize, setMinimize] = useState(false);
    const [formState, setFormState] = useState('view');
    const [disable, setDisable] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [col, setCol] = useState([]);
    const [itemId, setItemId] = useState(null);
    const [dCol, setDCol] = useState([]);

    const [visible, setVisible] = useState(false);
    const [inseamIds, setInseamIds] = useState([])
    const [sizeIds, setSizeIds] = useState([])
    const [sku, setSku] = useState(null)
    const [randomData, setRandomData] = useState([])
    const [demoData, setDemoData] = useState(false);
    const [flag, setFlag] = useState(true);
    const [updateFlag, setUpdateFlag] = useState(false);
    const [hasSize, setHasSize] = useState([])
    const [hasInseam, setHasInseam] = useState([])
    const [newSize, setNewSize] = useState([])
    const [newInseam, setNewInseam] = useState([])
    const [relatedTrans, setRelatedTrans] = useState([]);
    const [size, setSize] = useState();
    const [genderCategory, setGenderCategory] = useState(null);
    const [newID, setNewID] = useState(null);
    const [inseams, setInseams] = useState([]);
    const [sizes, setSizes] = useState([]);
    const [arrSizes, setArrSizes] = useState([])
    const [arr, setArr] = useState([])
    const [resList, setResList] = useState([])
    const [userId, setUserId] = useState([])

    function useQuery() {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    let query = useQuery();
    let mode = query.get("mode");
    let productID = query.get("product_id");


    useEffect(() => {
        dispatch(getProductForm(token, menuId, companyId))
        dispatch(getProductType(token, menuId))
        dispatch(getSeasonYear(token, menuId))
    }, [])
    // useLayoutEffect(() => {
    //     if (mode === "edit") {
    //         setFormState("formView")
    //         dispatch(getProductForm(token, menuId, companyId))
    //         dispatch(getOneItem(token, productID)).then((res) => {
    //             setNewSize(res.payload.size)
    //             setNewInseam(res.payload.inseam)
    //         })

    //     }
    // }, [formState])

    useLayoutEffect(() => {
        dispatch(getRights(token, menuId)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                setUserId(res?.payload?.user_id)
            }
        });
    }, [])

    const updatedColumns = [
        { title: "Item Code", dataIndex: "item_code", key: "item_code",
        render: (text, record) => (
            <Link target={"blank"} to={"product-info?mode=edit&product_id=" + record.item_id}>{text}</Link>
          ),
    },
    ];


    const relatedTransactions = [
        { title: "Transaction No", dataIndex: "transaction_no", key: "transaction_no" },
        { title: "Transaction Type", dataIndex: "transaction_type", key: "transaction_type" },
        { title: "Transaction Date", dataIndex: "transaction_date", key: "transaction_date" },
        { title: "Customer", dataIndex: "customer_name", key: "customer_name" },
        { title: "Term ", dataIndex: "term_name", key: "term_name", },
    ];

    const hanldeSubItems = (record) => {
        setDemoData(record)
        form.setFieldsValue({
            itemCode: record.item_id,
            upcCode: record.upc_code,
            nrfColorCode: record.nrf_color_code,
            nrfSizeCode: record.nrf_size_code,
        })
        setVisible(true)
    }

    const handleDeleteSubitem = (record) => {
        let array = [...randomData];
        let arrayInseam = [...inseamIds];
        let arraySize = [...sizeIds]

        let index = array.findIndex(i => {
            return i.item_code === record.item_code
        })
        array.splice(index, 1);

        let indexInseam = arrayInseam.findIndex(i => {
            return i === record.inseam
        })
        let indexSize = arraySize.findIndex(i => {
            return i === record.size
        })

        let deleteNowInseam = array.find(f => {
            return f.inseam === arrayInseam[indexInseam]
        })
        let deleteNowSize = array.find(f => {
            return f.size === arraySize[indexSize]
        })

        if (deleteNowInseam === undefined) {
            arrayInseam.splice(indexInseam, 1);
            setInseamIds(arrayInseam)
        }
        if (deleteNowSize === undefined) {
            arraySize.splice(indexSize, 1);
            setSizeIds(arraySize)
        }
        setRandomData(array)
        if (!flag) {
            dispatch(deleteItem(token, record.item_id)).then((res) => {
                dispatch(getCombination(token, itemId))
                setUpdateFlag(!updateFlag)
            })
        }
    }

    const handleDelete = () => {
        dispatch(deleteItem(token, itemId)).then((res) => {
            if (res.type === "DELETE_ITEM_SUCCESS") {
                notification('success', 'Item', res?.payload?.data)
                filterReset()
                dispatch(getAllItem(token, "Y")).then(res => {
                    if (res.type === "GET_ALL_ITEM_SUCCESS") {
                        setCol(Object.keys(res.payload?.data?.[0]))
                    }
                })
                // dispatch(getProductForm(token, menuId, dCompanyId))
            }
        })
    }

    const filterReset = () => {
        history.push({ pathname: '/product-info' })
        setFormState("view")
        setRandomData([]);
        setSizeIds([])
        setFlag(false);
        setItemId(null);
    }

    const formSave = () => {
        setSubmit(true);
    }

    useEffect(() => {
        if (productID && mode === "edit") {
            console.log("yesssssss 111")
            setFormState("formView")
            dispatch(getOneItem(token, productID)).then((res) => {
                setNewSize(res.payload.size)
                setNewInseam(res.payload.inseam)
            })
            dispatch(getCombination(token, productID)).then((res) => {
                console.log("yesssssss 222")
                if (res.type === "GET_COMBINATION_SUCCESS") {
                    console.log(res?.payload?.data, 'res?.payload?.data');
                    res?.payload?.data.sort(function (a, b) {
                        return a.inseam - b.inseam;
                    });
                    console.log("yesssssss 3333")
                    setRandomData(res?.payload?.data)
                    let inseamArr = [];
                    let sizeArr = [];
                    let unique = res?.payload?.data.filter((item, i, ar) => {
                        console.log({ IIIIIIPPPP: item })
                        console.log({ IIIIII: item.inseam_id })
                        console.log({ IIIIIISSSSS: item.size_id })
                        inseamArr.push(item.inseam_id)
                        sizeArr.push(item.size_id)
                    });

                    console.log({ "inseamArr in new": inseamArr })
                    console.log({ "sizeArr in New": sizeArr })
                    setHasInseam([... new Set(inseamArr)])
                    setHasSize([... new Set(sizeArr)])
                }
            })
            setDCol([])
            setDisable(false)
        } else {
            setDisable(true);
            setDCol([])
        }
    }, [productID])

    const handleTab = (key) => {
        if (key === "logs") {
            dispatch(getLog(token, { inv_product_type: "inv_product_type" }))
        }
        else if (key === "relatedItems") {
            dispatch(getRelatedTransactions(token, itemId)).then((res) => {
                setRelatedTrans(res?.payload?.data)
            })
        }
    }

    const handleOk = async (e) => {
        form.setFieldsValue({ [e.target.name]: e.target.value });
        await form.validateFields().then((values) => {
            let demoArray = [...randomData]
            demoArray.find(f => {
                if (f.item_code === demoData.item_code) {
                    f.upc_code = values.upcCode;
                    f.nrf_color_code = values.nrfColorCode;
                    f.nrf_size_code = values.nrfSizeCode;
                }
            })
            if (!flag) {
                dispatch(updateItem(token, values, demoData.item_id, "subItem")).then((res) => {
                    dispatch(getCombination(token, itemId))
                    setUpdateFlag(!updateFlag)
                })
            }


        });
        setVisible(false);
        form.setFieldsValue({
            // itemCode: null,
            upcCode: null,
            nrfColorCode: null,
            nrfSizeCode: null
        })
    };

    const handleCancel = () => {
        setVisible(false);
        form.setFieldsValue({
            itemCode: null,
            upcCode: null,
            nrfColorCode: null,
            nrfSizeCode: null
        })
    };

    useEffect(() => {
        // if (formState === "add") {
        let combination = inseamIds?.map(inseam => {
            let inseamName = inseam.split(/[- ]+/).pop();
            let inseamID = inseam.split("-");
            sizeIds?.map(size => {
                let sizeName = size.split(/[- ]+/).pop();
                let sizeID = size.split("-");
                if (sku !== undefined) {
                    let findData = randomData?.filter(rD => {
                        return rD.item_code === `${sku}-${inseamName}-${sizeName}`
                    });
                    // if(sku ==! )
                    if (findData.length <= 0) {
                        setRandomData((item) => [{
                            item_code: `${sku}-${inseamName}-${sizeName}`,
                            inseam_id: parseInt(inseamID[0]),
                            size_id: parseInt(sizeID[0]),
                            inseam: inseamName,
                            size: sizeName,
                            upc_code: null,
                            nrf_color_code: null,
                            nrf_size_code: null
                        }, ...item])
                    }
                }
            })
        })

    }, [inseamIds, sizeIds, formState, sku])

    // useEffect(() => {
    //     if (!flag) {
    //         setInseamIds([])
    //         setSizeIds([])
    //     }
    // }, [flag])

    useEffect(() => {
        if (formState === "add") {
            setRandomData([])
            setInseamIds([])
            setSizeIds([])
            setArrSizes([])
            setArr([])
        }
    }, [formState])

    return (
        <div className='styleContainer' >
            <div className='styleBody h-100' >
                <PageHeader userRights={userRights?.payload} title={"Product Information"} minimize={setMinimize} check={minimize} type={formState} />
                {!minimize &&
                    <div className='bodyStyle'>
                        {formState !== "table" ?
                            <>
                                {(productForm.loading) || (item && item?.loading) || (styleCombination && styleCombination.loading) ?
                                    <div className='loaderDiv' >
                                        <Loader
                                            type="Grid"
                                            color="#212121"
                                            height={40}
                                            width={40}
                                        />
                                    </div> :
                                    null}
                            </> : null}
                        <div className='crudDiv' >

                            <div className='mainProductContainer' style={formState === "table" ? { height: "83vh", overflowY: "hidden" } : {}}  >
                                <>
                                    <SubTitle name={"Update Primary Information"} />
                                    <ProductPrimaryFormForUpdate
                                        setNewID={setNewID}
                                        newID={newID}
                                        dCompany={dCompanyId}
                                        formState={formState}
                                        changeState={setFormState}
                                        defaultCompany={companyId}
                                        companyId={setCompanyId}
                                        submit={setSubmit}
                                        val={submit}
                                        token={token}
                                        formData={(formState === "formView" || formState === "edit" || formState === "view") ? item?.payload : null}
                                        data={productForm}
                                        sku={setSku}
                                        valSKU={sku}
                                        randomData={randomData}
                                        combinationData={setRandomData}
                                        flagSet={setFlag}
                                        itemId={productID}
                                        size={size}
                                        setSize={setSize}
                                        genderCategory={genderCategory}
                                        setGenderCategory={setGenderCategory}
                                        newSize={newSize}
                                        newInseam={newInseam}
                                        inseams={inseams}
                                        setInseams={setInseams}
                                        sizes={sizes}
                                        setSizes={setSizes}
                                        seasonYear={seasonYear}
                                        productID={productID}
                                        arrSizes={arrSizes}
                                        setArrSizes={setArrSizes}
                                        arr={arr}
                                        setArr={setArr}
                                        setResList = {setResList}
                                        resList = {resList}
                                        userId = {userId}
                                    />
                                    <SubTitle name={"Logs"} />
                                    <div className='productTabs p-10-all'>
                                        <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered onChange={(key) => handleTab(key)}>
                                            <TabPane tab="Message" key="1">
                                                <div className='tabs' >
                                                    <Tables
                                                        scrollX={"50rem"}
                                                        type="combination"
                                                        scroll={250}
                                                        perPage={10}
                                                        source={resList && resList.sort()}
                                                        col={updatedColumns}
                                                        paginate />
                                                </div>
                                            </TabPane>
                                           
                                        </Tabs>
                                    </div>

                                </>
                            </div>

                        </div>
                    </div>
                }
            </div>
            {
                minimize &&
                <div className='styleFooter' >
                    <Button className='minimize-button-style' onClick={() => setMinimize(false)}  >Product</Button>
                </div>
            }
            <div className='modalForm' >
                <Modal
                    title="Update"
                    visible={visible}
                    onCancel={handleCancel}
                    footer={[
                        <Button onClick={() => handleCancel()} >Cancel</Button>,
                        <Button type='primary' onClick={(e) => handleOk(e)} disabled={((demoData.item_id && flag) ? true : false)} >UPDATE</Button>,
                    ]}
                >
                    <div className='' >
                        <Form onFinish={handleOk} form={form} name="basic">
                            <Row justify="space-between">
                                <Col xs={24} sm={24} md={24} lg={24}>
                                    <Form.Item
                                        labelCol={{ span: 6 }}
                                        label="UPC Code"
                                        name="upcCode"
                                        labelAlign="left"
                                        rules={[
                                            {
                                                pattern: new RegExp(/^[0-9]*$/),
                                                message: "Characters not allowed",
                                            },
                                        ]}
                                    >
                                        <Input className='radius-5' />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24}>
                                    <Form.Item
                                        labelCol={{ span: 6 }}
                                        label="NRF Color Code"
                                        name="nrfColorCode"
                                        labelAlign="left"
                                        rules={[
                                            {
                                                pattern: new RegExp(/^[0-9]*$/),
                                                message: "Characters not allowed",
                                            },
                                        ]}
                                    >
                                        <Input className='radius-5' />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24}>
                                    <Form.Item
                                        labelCol={{ span: 6 }}
                                        label="NRF Size Code"
                                        name="nrfSizeCode"
                                        labelAlign="left"
                                        rules={[
                                            {
                                                pattern: new RegExp(/^[0-9]*$/),
                                                message: "Characters not allowed",
                                            },
                                        ]}
                                    >
                                        <Input className='radius-5' />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Modal>
            </div>
        </div >
    )
}
